$( document ).ready(function() {
    // let quemUsa = $("a[href=\"#quem-usa\"]");
    // quemUsa.each(function() {
    //   console.log($(this))
    //   $(this).on("click", function() {
    //     let redirectTo = window.location;
    //     return redirectTo;
    //   })
    // })
});